module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-center",
    style: ({
      'height': _vm.contentH + 'px'
    })
  }, [_c('div', {
    staticClass: "field-block"
  }, [_c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title field-title-user"
  }, [_vm._v(_vm._s(_vm.userInfo.realname) + " / " + _vm._s(_vm.userInfo.workerId) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "field-row field-row-second"
  }, [_c('div', {
    staticClass: "field-title"
  }, [_vm._v("角色")]), _vm._v(" "), _c('div', {
    staticClass: "field-values"
  }, _vm._l((_vm.userInfo.roleNames), function(role, index) {
    return _c('div', {
      key: index,
      staticClass: "field-value"
    }, [_vm._v(_vm._s(role))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title"
  }, [_vm._v("部门")]), _vm._v(" "), _c('div', {
    staticClass: "field-values"
  }, _vm._l((_vm.userInfo.departIdList), function(dept, index) {
    return _c('div', {
      key: index,
      staticClass: "field-value"
    }, [_vm._v(_vm._s(dept))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title"
  }, [_vm._v("Franchise/DA")]), _vm._v(" "), _c('div', {
    staticClass: "field-values"
  }, _vm._l((_vm.userInfo.medicalFieldList), function(medical_field, index) {
    return _c('div', {
      key: index,
      staticClass: "field-value"
    }, [_vm._v(_vm._s(medical_field))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title"
  }, [_vm._v("团队")]), _vm._v(" "), _c('div', {
    staticClass: "field-values"
  }, _vm._l((_vm.userInfo.loginTeams), function(team, index) {
    return _c('div', {
      key: index,
      staticClass: "field-value"
    }, [_vm._v(_vm._s(team.teamName))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title"
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('div', {
    staticClass: "field-values"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.userInfo.email))])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3f6fd5ea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f6fd5ea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/user/center/index.vue
// module id = 758
// module chunks = 7